import React from "react";
import { ColumnDef } from "@tanstack/react-table";
import { FaEye } from "react-icons/fa";
import DataTable from "../../../component/element/table";
import { useAppDispatch, useAppSelector } from "../../../store";
import { get_admin_users } from "../../../services/apis/admin-user";
import { IAdminUser } from "../../../store/types/admin-users";
import AdminUser from "./AdminUser";

const ListAdminUser: React.FC = () => {
  const dispatch = useAppDispatch();
  const { admins, limit, total, loading } = useAppSelector(
    ({ admin }) => admin,
  );
  const [page, setPage] = React.useState(1);
  const [selectedAdmin, setSelectedAdmin] = React.useState<IAdminUser | null>(
    null,
  );
  const lastPage = Math.max(1, Math.ceil(total / limit));

  React.useEffect(() => {
    if (page > lastPage) {
      setPage(lastPage);
      return;
    }
    void get_admin_users(dispatch, limit, (page - 1) * limit);
  }, [dispatch, lastPage, limit, page]);

  const columns: ColumnDef<IAdminUser>[] = [
    {
      accessorKey: "profile.name",
      header: "Name",
      cell: ({ getValue }) => (
        <span className="font-medium text-gray-900">
          {(getValue() as string) || "—"}
        </span>
      ),
    },
    {
      accessorKey: "email",
      header: "Email",
    },
    {
      accessorKey: "username",
      header: "Username",
      cell: ({ getValue }) => (getValue() as string) || "—",
    },
    {
      accessorKey: "role",
      header: "Role ID",
    },
    {
      accessorKey: "is_active",
      header: "Account",
      cell: ({ getValue }) => (getValue() ? "Active" : "Inactive"),
    },
    {
      id: "actions",
      header: "Actions",
      cell: ({ row }) => (
        <button
          type="button"
          className="text-gray-600 hover:text-primary-600"
          aria-label={`View ${row.original.email}`}
          onClick={() => setSelectedAdmin(row.original)}
        >
          <FaEye size={20} />
        </button>
      ),
    },
  ];

  return (
    <div className="w-full h-full">
      {loading && (
        <p className="mb-2 text-sm text-gray-500" role="status">
          Loading admin users...
        </p>
      )}
      <DataTable
        columns={columns}
        data={admins}
        current_page={page}
        last_page={lastPage}
        onNext={() => page < lastPage && setPage(page + 1)}
        onPrev={() => page > 1 && setPage(page - 1)}
      />

      {selectedAdmin && (
        <AdminUser
          show
          data={selectedAdmin}
          onCancel={() => setSelectedAdmin(null)}
        />
      )}
    </div>
  );
};

export default ListAdminUser;
